import { useReduxState } from 'hooks';
import { FormGroup } from 'components/common/form';
import { CheckboxInput } from 'components/common/form/common';

import type { AllTaskBlocks } from 'shared-types';

interface Props {
  blockId: number;
  data: AllTaskBlocks;
  disabled?: boolean;
  updateData: (data: AllTaskBlocks) => void;
}

const EditorBlockIsMandatorySettings = ({
  blockId,
  data,
  disabled,
  updateData
}: Props) => {
  const { messages } = useReduxState();

  const handleIsMandatoryChange = (ev) => {
    const value = ev.target.checked;
    updateData({
      ...data,
      ...(value ? {} : { requireAnswerToProceed: false }),
      isMandatory: value
    });
  };

  const handleProceedChange = (ev) => {
    const value = ev.target.checked;
    updateData({
      ...data,
      ...(value ? { isMandatory: true } : {}),
      requireAnswerToProceed: value
    });
  };

  return (
    <FormGroup label={messages.editorBlockRequireAnswer} maxWidth="100%">
      <CheckboxInput
        checked={Boolean(data?.isMandatory)}
        disabled={disabled || ('isTask' in data && data.isTask === false)}
        id={`require-answer-to-complete-${blockId}`}
        label={messages.editorBlockIsMandatory}
        labelTooltip={messages.editorBlockIsMandatoryInfo}
        onChange={handleIsMandatoryChange}
        stopPropagation={true}
      />

      <CheckboxInput
        checked={Boolean(data?.requireAnswerToProceed)}
        disabled={disabled || ('isTask' in data && data.isTask === false)}
        id={`require-answer-to-proceed-${blockId}`}
        label={messages.editorBlockRequireAnswerToProceedLabel}
        labelTooltip={messages.editorBlockRequireAnswerToProceedInfoDetailed}
        onChange={handleProceedChange}
        stopPropagation={true}
        style={{ marginTop: 5 }}
      />
    </FormGroup>
  );
};

export default EditorBlockIsMandatorySettings;
